import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Router} from '@angular/router';
import {RaintreeResponse} from 'src/app/raintree/interface/raintree-response';
import {
	SuccessFailTransactionTransmissionService
} from 'src/app/raintree/transmission/success-fail-transaction-transmission/success-fail-transaction-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {PaymentFaliureTransaction} from '../interface/payment-faliure-transaction';
import {isPlatformBrowser} from '@angular/common';


@Injectable({
	providedIn: 'root'
})
export class FaliureTransactionService {

	public isBrowser: boolean = false;
	constructor(
		private _transactionRequest: SuccessFailTransactionTransmissionService,
		public _toast: ToastMessageService,
		private _router: Router,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	 }


	public faliureRequest(error: PaymentFaliureTransaction) {
		// debugger
		console.log("faliure called");
		// this._razorPayService.paymentFailedInitiated = true;
		this.paymentFailRequest(error);
	}


	public paymentFailRequest(payload: PaymentFaliureTransaction) {

		this._transactionRequest.failTransaction(
			RequestMapperService.PAYMENT_FAIL,
			payload,
			() => { },
			() => { },
			(response: RaintreeResponse) => {
				// debugger
				this._toast.error('Pyment Failed', 'Payment was unsuccessful due to a temporary issue.');

				// this._router.navigate(['./profile/order/' + payload.loomOrderId]).then(() => {
				// 	if (this.isBrowser){
				// 		window.location.reload();
				// 	}

				// }); //TODO: DO not remove
			},
			(error: string) => {
				// debugger
				this._toast.error(error, error);
			},
			() => {
			}
		)
	}
}
